// extracted by mini-css-extract-plugin
export default {"container":"tm-z","blurb":"um-z","links":"vm-z"};